<div class="component-container">

    <div class="reset-password-container">
        <h1>Reset Password</h1>
        <p class="description">Please enter your new password below.</p>
        
        <div class="success-message" id="successMessage">
            Your password has been reset successfully!
        </div>
        
        <form id="resetPasswordForm" #form="ngForm" (ngSubmit)="resetPassword()">
            <div class="form-group">
                <label for="password">New Password</label>
                <div class="password-container">
                    <input [type]="show ? 'text' : 'password'" name="password" placeholder="Enter new password" required
                    [(ngModel)]="password" autocomplete="off"
                    #credential="ngModel"
                    minlength="8"
                    pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
                    >
                    <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggle()">Show</button>
                </div>

            
                <div class="error-message" id="passwordError" [style.display]="(credential.invalid && (credential.dirty || credential.touched)) ? 'block' : 'none'">
                    <ul>
                        <li *ngIf="credential.errors?.required">Password is required</li>
                        <li *ngIf="credential.errors?.minlength">Must be at least 8 characters long</li>
                        <li *ngIf="credential.errors?.pattern">
                          Must include at least one uppercase letter, one number, and one special character
                        </li>
                      </ul>
                </div>
                
            </div>
            
            <div class="form-group">
                <label for="confirmPassword">Confirm New Password</label>
                <div class="password-container">
                    <input [type]="show2 ? 'text' : 'password'" name="confirmPassword" placeholder="Confirm new password" required
                    [(ngModel)]="confirmPassword" autocomplete="off"
                    #confirmCredential="ngModel"
                    minlength="8"
                    pattern="^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$"
                    >
                    <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggle2()">Show</button>
                </div>
                <div class="error-message" id="confirmPasswordError"  [style.display]="(confirmCredential.invalid && (confirmCredential.dirty || confirmCredential.touched)) ? 'block' : 'none'">
                    <ul>
                        <li *ngIf="confirmCredential.errors?.required">Password is required</li>
                        <li *ngIf="confirmCredential.errors?.minlength">Must be at least 8 characters long</li>
                        <li *ngIf="confirmCredential.errors?.pattern">
                          Must include at least one uppercase letter, one number, and one special character
                        </li>
                      </ul>
                </div>
            </div>
            
            <button type="submit" class="btn" [disabled]="form.invalid">Set New Password</button>
            <p class="login-link">Remember your password? <a [routerLink]="['/login']">Back to Login</a></p>
        </form>
    </div>
</div>